export class Role {
  rol: String;
  descripcion: String;
}
